import { FlexRow, formatSecondsToHMS, mediaQuery, type SpotlightLink, useListSpotlights } from '@fuuze/shared';
import styled from 'styled-components';
import { useShallow } from 'zustand/react/shallow';
import { usePlayerStore } from '../../store/player.store';
import { CustomPlayerSlider } from './custom-player-slider';

type PlayerSliderProps = {
  disabled?: boolean;
};

export function PlayerSlider({ disabled }: PlayerSliderProps) {
  const [duration, isPlayerLoading, playerPosition, podcastPlaying, seek, setPosition, setSpotlight] = usePlayerStore(
    useShallow(state => [
      state.duration,
      state.isLoading,
      state.playerPosition,
      state.podcastPlaying,
      state.seek,
      state.setPosition,
      state.setSpotlight,
    ]),
  );
  const spotlights = useListSpotlights(podcastPlaying?.item._id);

  const onSliderChangeEnd = async (value: number, spotlight?: SpotlightLink) => {
    await seek(value);
    setSpotlight(spotlight);
  };

  const onSliderChange = (value: number, spotlight?: SpotlightLink) => {
    setPosition(value);
    setSpotlight(spotlight);
  };

  return (
    <SliderWrapper>
      <SliderLabel>{formatSecondsToHMS(playerPosition)}</SliderLabel>
      <CustomPlayerSlider
        disabled={disabled}
        max={duration}
        value={playerPosition}
        onSliderChange={onSliderChange}
        onSliderChangeEnd={onSliderChangeEnd}
        spotlights={spotlights.data?.links}
        loading={isPlayerLoading}
      />
      <SliderLabel>-{formatSecondsToHMS(duration - playerPosition)}</SliderLabel>
    </SliderWrapper>
  );
}

const SliderWrapper = styled(FlexRow)`
  gap: 8px;
  align-items: center;
`;

const SliderLabel = styled.small`
  font-size: 11px;
  color: ${props => props.theme.colors.dark.dark800};

  @media ${mediaQuery.tablet} {
    font-size: 12px;
  }
`;
